import React, { useContext, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { AuthContext } from './index';

/**
 * A wrapper component that checks if the user is authenticated
 * and redirects to the login page if not
 */
export const RequireAuth = ({ children }) => {
  const { isAuthenticated, accessToken } = useContext(AuthContext);
  const navigate = useNavigate();
  const location = useLocation();
  
  useEffect(() => {
    console.log('RequireAuth - checking authentication:', { 
      isAuthenticated, 
      hasToken: !!accessToken,
      path: location.pathname
    });
    
    // If not authenticated, redirect to login
    if (!isAuthenticated) {
      console.log('User not authenticated. Saving redirect path and navigating to login.');
      
      // Save the current path to redirect back after login
      // Make sure we preserve the underscore version for consistency
      const redirectPath = location.pathname;
      localStorage.setItem('afterLoginRedirect', redirectPath);
      
      navigate('/auth');
    }
  }, [isAuthenticated, accessToken, navigate, location]);
  
  // If authenticated, render the children components
  return isAuthenticated ? children : (
    <div className="auth-required-container">
      <h2>Authentication Required</h2>
      <p>Loading...</p>
    </div>
  );
};

export default RequireAuth; 